<template>
	<div>
		<article class="iv2-article" v-if="pageActive">
			<LayoutTitle :title="title" :subtitle="subtitle" />
			<LayoutDetail :news="news" />
		</article>
		<div v-if="loading">
			<BaseLoading />
		</div>
	</div>
</template>

<script>
import LayoutTitle from "./components/LayoutTitle.vue";
import LayoutDetail from "./components/LayoutDetail.vue";
import BaseLoading from "@/components/items/BaseLoading.vue";

import Meta from "@/mixins/MetaSettable";
import Preview from "@/mixins/Preview";

export default {
	mixins: [Meta, Preview],

	props: ["animation"],

	components: {
		LayoutTitle,
		LayoutDetail,
		BaseLoading,
	},

	data() {
		return {
			news: [],
			title: "",
			subtitle: "",
			pageActive: false,
			loading: true,
		};
	},

	mounted() {
		const id = this.$route.params.id
		if(this.$route.query.mode == 'preview') {
			this.axios.get("/preview/news", {
				headers: {
					Authorization: `Bearer ${this.$cookies.get('preview-token')}`,
				}
			}).then(({data}) => {
				this.title = data.response.title;
				this.subtitle = data.response.subtitle;
			});
			this.axios.get("/preview/news/" + id + "/show", {
				headers: {
					Authorization: `Bearer ${this.$cookies.get('preview-token')}`,
				}
			}).then((response) => {
				this.news = response.data.response;
				this.loading = false;
				this.pageActive = true;
			}).catch(() => {
				this.loading = false;
				this.pageActive = true;
			});
		}else{
			this.axios.get("/news").then(({data}) => {
				this.title = data.response.title;
				this.subtitle = data.response.subtitle;
			});
			this.axios.get("/news/" + id + "/show").then((response) => {
				this.news = response.data.response;
				this.loading = false;
				this.pageActive = true;
			}).catch(() => {
				this.loading = false;
				this.pageActive = true;
			});
		}
	},
};
</script>

<style lang="scss"></style>
